module.exports = __webpack_public_path__ + "static/media/aboutBcg.7709c10e.jpeg";